import { render } from "./RiAlert.vue?vue&type=template&id=82a82842"
import script from "./RiAlert.vue?vue&type=script&lang=js"
export * from "./RiAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiAlert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "82a82842"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82a82842', __exports__)) {
    api.reload('82a82842', __exports__)
  }
  
  module.hot.accept("./RiAlert.vue?vue&type=template&id=82a82842", () => {
    api.rerender('82a82842', render)
  })

}


export default __exports__